import React from 'react'
import { AddRequirementModalProvider } from './context/AddRequirementModalProvider'
import { AddRequirementModalMain } from './components/AddRequirementModalMain'

type AddRequirementModalProps = {
  open: boolean
  onClose: () => void
}

export const AddRequirementModal = ({
  open,
  onClose,
}: AddRequirementModalProps) => (
  <AddRequirementModalProvider>
    <AddRequirementModalMain open={open} onClose={onClose} />
  </AddRequirementModalProvider>
)
